import EnvironmentSettings from "../../Models/EnvironmentSettings";
import TenantManager from "../TenantManager";
import UsersApi from "../UsersApi";

class FacilitiesApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
    //console.log("baseUrl: ", this.baseUrl);
  }

  //*************** Facility Types ***********************************

  CreateFacilityTypeUrl = "Admin/CreateFacilityType";
  EditFacilityTypeUrl = "Admin/EditFacilityType";
  DeleteFacilityTypeUrl = "Admin/DeleteFacilityType";
  GetFacilityTypeByIdUrl = "Admin/GetFacilityTypeById";
  SearchFacilityTypesUrl = "Admin/SearchFacilityTypes";

  async GetFacilityTypeById(req) {
    const res = await fetch(this.baseUrl + this.GetFacilityTypeByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async CreateFacilityType(req) {
    const res = await fetch(this.baseUrl + this.CreateFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }
  async EditFacilityType(req) {
    const res = await fetch(this.baseUrl + this.EditFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteFacilityType(req) {
    const res = await fetch(this.baseUrl + this.DeleteFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchFacilityTypes(req) {
    const res = await fetch(this.baseUrl + this.SearchFacilityTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  //*************** Facility***********************************

  CreateFacilityUrl = "Admin/CreateFacility";
  EditFacilityUrl = "Admin/EditFacility";
  DeleteFacilityUrl = "Admin/DeleteFacility";
  GetFacilityByIdUrl = "Admin/GetFacilityById";
  SearchFacilitiesUrl = "Admin/SearchFacilities";

  async GetFacilityById(req) {
    const reqBody = await fetch(this.baseUrl + this.GetFacilityByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    console.log(data);
    return data;
  }

  async CreateFacility(req, setErrorText) {
    let form = new FormData();
    form.append("Id", req.Id);
    form.append("Description", req.Description);
    form.append("Category", req.Category);
    form.append("InitialPrice", req.InitialPrice);
    form.append("CurrentPrice", req.CurrentPrice);
    form.append("DepreciationRate", req.DepreciationRate);
    form.append("DatePurchased", req.DatePurchased);
    form.append("AccountingEntryId", req.AccountingEntryId);
    form.append("CreateAccountingEntry", req.CreateAccountingEntry);
    form.append("TypeId", req.TypeId);

    if (req.Image.files.length > 0) {
      for (var index = 0; index < req.Image.files.length; index++) {
        if (!this.isFileImage(req.Image.files[index])) {
          setErrorText("Please upload valid image files only");
          return;
        }

        var element = req.Image.files[index];
        // Images.push(element);
        form.append("Image", element);
      }
    }

    const res = await fetch(this.baseUrl + this.CreateFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        // 'Content-type': 'application/json'
      },
      body: form,
    });

    const data = await res.json();
    console.log(data);

    return data;
  }

  async EditFacility(req) {
    const res = await fetch(this.baseUrl + this.EditFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteFacility(req) {
    const res = await fetch(this.baseUrl + this.DeleteFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchFacilities(req) {
    const res = await fetch(this.baseUrl + this.SearchFacilitiesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  isFileImage(file) {
    return file && file["type"].split("/")[0] === "image";
  }
  //*************** Facility Types ***********************************

  CreateFacilityTypeUrl = "Admin/CreateFacilityType";
  EditFacilityTypeUrl = "Admin/EditFacilityType";
  DeleteFacilityTypeUrl = "Admin/DeleteFacilityType";
  GetFacilityTypeByIdUrl = "Admin/GetFacilityTypeById";
  SearchFacilityTypesUrl = "Admin/SearchFacilityTypes";

  async CreateFacilityType(req) {
    const res = await fetch(this.baseUrl + this.CreateFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }
  async EditFacilityType(req) {
    const res = await fetch(this.baseUrl + this.EditFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteFacilityType(req) {
    const res = await fetch(this.baseUrl + this.DeleteFacilityTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchFacilityTypes(req) {
    const res = await fetch(this.baseUrl + this.SearchFacilityTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  //*************** Facility***********************************

  CreateFacilityUrl = "Admin/CreateFacility";
  EditFacilityUrl = "Admin/EditFacility";
  DeleteFacilityUrl = "Admin/DeleteFacility";
  GetFacilityByIdUrl = "Admin/GetFacilityById";
  SearchFacilitiesUrl = "Admin/SearchFacilities";

  async CreateFacility(req, setErrorText) {
    let form = new FormData();
    form.append("Id", req.Id);
    form.append("Name", req.Name);

    form.append("Description", req.Description);
    form.append("Category", req.Category);
    form.append("InitialPrice", req.InitialPrice);
    form.append("CurrentPrice", req.CurrentPrice);
    form.append("DepreciationRate", req.DepreciationRate);
    form.append("DatePurchased", req.DatePurchased);
    form.append("AccountingEntryId", req.AccountingEntryId);
    form.append("CreateAccountingEntry", req.CreateAccountingEntry);
    form.append("TypeId", req.TypeId);

    if (req.Image.files.length > 0) {
      for (var index = 0; index < req.Image.files.length; index++) {
        if (!this.isFileImage(req.Image.files[index])) {
          setErrorText("Please upload valid image files only");
          return;
        }

        var element = req.Image.files[index];
        // Images.push(element);
        form.append("Image", element);
      }
    }

    const res = await fetch(this.baseUrl + this.CreateFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        // 'Content-type': 'application/json'
      },
      body: form,
    });

    const data = await res.json();
    console.log(data);

    return data;
  }

  async EditFacility(req) {
    req.Image = undefined;
    const res = await fetch(this.baseUrl + this.EditFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteFacility(req) {
    const res = await fetch(this.baseUrl + this.DeleteFacilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchFacilities(req) {
    const res = await fetch(this.baseUrl + this.SearchFacilitiesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  isFileImage(file) {
    return file && file["type"].split("/")[0] === "image";
  }
}

export default new FacilitiesApi();
